import { EmptyAvatarVariantEnum } from '@sweatpals/shared';

export interface MenuOption {
	id: string;
	name: string;
}

export type OptionWithChildren<T> = T & { children?: T[] };

export class UsersAutocompleteOption {
	public id: string;
	public fullName: string;
	public avatarId?: string;
	public emptyAvatarVariant?: EmptyAvatarVariantEnum;
	public avatarSrc?: string;
	public email?: string;
	public phone?: string;
}

export class PlacesAutocompleteOption {
	public id: string;
	public description: string;
	public formattedSuggestion: {
		mainText: string;
		secondaryText?: string;
	};
}

export class EventAutocompleteOption {
	public id: string;
	public baseId: string;
	public instance: Date | string;
	public name: string;
	public alias: string;
	public shortLocalInstance: string;
	public avatarId?: string;
	public avatarUrl?: string;
}
